import axios from 'axios'
export default class AppVars {
    static instance = null;
    env = null;
    data = null;



    static getInstance() {
        if (AppVars.instance == null){
            AppVars.instance = new AppVars();
        }
        return this.instance;
    }

    setEnv(){
        const url = window.location.href
        const domain = url.replace(/^(?:https?:\/\/)(?:www\.)?/i, '').split('/')[0];
        let env = domain.split(".")[0]
        if (env === "account"){
            env = "prod"
        }
        this.env = env;
    }

    setData(env){
        switch(env){
            case "local":
                AppVars.instance.data = require('./static/envs/local.json');
                break;
            case "localhost:3000":
                AppVars.instance.data = require('./static/envs/local.json');
                break;
            case "localhost:8433":
                AppVars.instance.data = require('./static/envs/local.json');
                break;
            case "dev":
                AppVars.instance.data = require('./static/envs/dev.json');
                break;
            case "test":
                AppVars.instance.data = require('./static/envs/test.json');
                break;
            case "stage":
                AppVars.instance.data = require('./static/envs/stage.json');
                break;
            case "prod":
                AppVars.instance.data = require('./static/envs/prod.json');
                break;
            default:
                AppVars.instance.data = require('./static/envs/test.json');
        }
    }

    
    getEnv(){
        return this.env;
    }

    getBaseUrl(){
        return this.data.baseurl;
    }

    getDomain(){
        return this.data.domain;
    }

    getName(){
        return this.data.name;
    }

    getRealm(){
        return this.data.realm;
    }

    getEmailSignInTree(){
        return this.data.emailTree;
    }

    getGoogleSignInTree(){
        return this.data.googleTree;
    }

    getFacebookSignInTree(){
        return this.data.facebookTree;
    }

    getAppleSignInTree(){
        return this.data.appleTree;
    }

    getPhoneSignInTree(){
        return this.data.phoneTree;
    }

    getMFATree(){
        return this.data.mfaTree;
    }

    getGoogleSignUpTree(){
        return this.data.googleSignUpTree;
    }

    getMakePasswordTree(){
        return this.data.makePasswordTree;
    }

    getSignInTree(){
        return this.data.signInTree;
    }

    getResetPasswordTree(){
        return this.data.resetPasswordTree;
    }

    getGoogleReferrers(){
        return this.data.validGoogleReferrers;
    }

    getFacebookReferrers(){
        return this.data.validFacebookReferrers;
    }

    getCookieName(){
        return this.data.cookieName;
    }

    getIncludeSignIn(TYPE){
        switch(TYPE){
        case "EMAIL":
            return this.data.includeEmail;
        case "GOOGLE":
            return this.data.includeGoogle;
        case "FACEBOOK":
            return this.data.includeFacebook;
        case "APPLE": 
            return this.data.includeApple;
        case "PHONE":
            return this.data.includePhone;
        }
    }

    getAzureWeb(){
        return this.data.azureWeb;
    }

    getAPIGatewayURL(){
        return this.data.APIGatewayURL;
    }
    
    getECPCApiGatewayURL(){
        return this.data.ECPCApiGatewayURL;
    }

    getIDMBaseURL() {
        return this.data.IDMBaseURL;
    }

    getAMBaseURL() {
        return this.data.AMBaseURL;
    }

    getResendActivationEmailURL(style){
        switch(style){
            case "TO":
                return this.data.TOResendActivationEmailURL;
            case "DG":
                return this.data.DGResendActivationEmailURL;
            default:
                return this.data.TOResendActivationEmailURL;
        }

    }

    getDefaultRedirectURI() {
        return this.data.defaultRedirectUri
    }

    getDefaultClientId() {
        return this.data.defaultClientId
    }

    getDefaultHomePage() {
        return this.data.defaultHomePage
    }
    getSupportURL(){
        return this.data.SupportURL
    }

    getRegisterURL(style){
        switch(style){
            case "TO":
                return this.data.TORegisterURL;
            case "DG":
                return this.data.DGRegisterURL;
            default:
                return this.data.TORegisterURL;
        }
    }

    getForgotPasswordURL(style){
        switch(style){
            case "TO":
                return this.data.TOForgotPasswordURL;
            case "DG":
                return this.data.DGForgotPasswordURL;
            default:
                return this.data.TOForgotPasswordURL;
        }
    }

    getUnknownErrorURL(style){
        switch(style){
            case "TO":
                return this.data.TOErrorPageURL;
            case "DG":
                return this.data.DGErrorPageURL;
            default:
                return this.data.DGErrorPageURL
        }
    }

    getAppHomeURL(style){
        switch(style){
            case "TO":
            return this.data.TOHomeURL;
        case "DG":
            return this.data.DGHomeURL;
        }
    }
    
    getEmailBrand(style){
        switch(style){
            case "TO":
                return this.data.TOEmailBrand;
            case "DG":
                return this.data.DGEmailBrand;
            default:
                return null
        }
    }

    getEmailMessageType(style){
        switch(style){
            case "TO":
                return this.data.TOEmailMessageType;
            case "DG":
                return this.data.DGEmailMessageType;
            default:
                return null
        }
    }

    //   getLogo(style){
    //     switch(style){
    //         case "TO":
    //             return this.data.TOLogo;
    //         case "DG":
    //             return this.data.DGLogo;
    //         default:
    //             return this.data.TOLogo;
    //       }
    //   }

}